<template>
    <tr class="attribute-option-list-row-wrapper attribute-option-row">
        <!-- Order -->
        <td class="order-column">
            <edit-in-place type="number"
                            class="edit-in-place-cell"
                            :property-value="sortOrderValue"
                            :isMaster="versionId === '0'"
                            :masterValue="sortOrderMaster"
                            :show-save-and-sync="true">
                <api-handler change-type="sort" :option-id="optionId" :version-id="versionId" v-on="$listeners">
                </api-handler>
            </edit-in-place>
        </td>
        <!-- Value -->
        <td class="value-column">
            <edit-in-place type="short-text"
                            class="edit-in-place-cell"
                            :property-value="propertyValue"
                            :isMaster="versionId === '0'"
                            :masterValue="valueMaster"
                            :show-save-and-sync="true">
                <api-handler :change-type="valueChangeType" :option-id="optionId" :version-id="versionId" v-on="$listeners" :attribute-id="attributeOptionData.attributeId"></api-handler>
            </edit-in-place>
        </td>
        <!-- Row -->
        <td class="delete-column">
            <div v-if="versionId == '0'" @mouseleave="showDelete=false">
                <i class="trash-can ks-icon fa la-fw fa-trash" v-if="!showDelete" @mouseover="showDelete=true"></i>
                <delete-toggle v-if="showDelete" @remove="handleDeleteRow" label="Delete"></delete-toggle>
            </div>
            <hover-message v-if="showDelete && versionId == '0'" colour-scheme="warning" position="left" :message="msgDeletingWarning"></hover-message>
            <hover-message v-if="showDelete && versionId != '0'" colour-scheme="warning" position="left" :message="msgClearingWarning"></hover-message>
        </td>
    </tr>
</template>

<script>

import axios from 'axios';
import EditInPlace from '../edit-in-place/edit-in-place.vue';
import AttributesOptionApiHandler from './attributes-option-api-handler.vue';
import DeleteToggle from '../generic/delete-toggle.vue';
import HoverMessage from '../generic/hover-message.vue';

let base_url = window.location.protocol + "//" + window.location.host;

export default {
    name: 'attribute-option-list-row',
    components: {
        'delete-toggle': DeleteToggle,
        'edit-in-place': EditInPlace,
        'api-handler': AttributesOptionApiHandler,
        'hover-message': HoverMessage,
    },
    props: {
        attributeOptionData: Object,
        versionId: String
    },
    data() {
        return {
            showDelete: false,
        }
    },
    computed: {
        msgDeletingWarning() {
            if (this.attributeOptionData['isValueAssignedToProducts']) {
                return "WARNING: Deleting will automatically remove from assigned products and trigger a sync";
            }
            else {
                return "Deleting will automatically trigger a sync";
            }
        },
        msgClearingWarning() {
            if (this.attributeOptionData['isValueAssignedToProducts']) {
                return "WARNING: Clearing will automatically remove from assigned products and trigger a sync";
            }
            else {
                return "Clearing will automatically trigger a sync";
            }
        },
        sortOrderValue() {
            if (this.versionId === "0") {
                return this.sortOrderMaster;
            }
            return this.sortOrderVersion;
        },
        hasVersionableOverrides() {
            let v = this.attributeOptionData.versions.filter(element => {
                return ((element.languageId + '') == this.versionId)
            });

            return v.length > 0;

        },
        optionId() {
            if (this.versionId != "0") {

                let v = this.attributeOptionData.versions.filter(element => {
                    return ((element.languageId + '') == this.versionId)
                });

                if (v.length > 0) {
                   return v[0].id + '';
                }
            }

            return this.attributeOptionData.id + '';
        },
        sortOrderMaster() {

            let sOrder = this.attributeOptionData.sortOrder;

            if (sOrder == null) {
                return '';
            }
            if (isNaN(sOrder)) {
                return '';
            }

            return sOrder + '';
        },
        sortOrderVersion() {

            let sOrder = '';
            if (this.versionId != "0" && this.attributeOptionData.versions.length > 0) {

                let v = this.attributeOptionData.versions.filter(element => {
                    return ((element.languageId + '') == this.versionId)
                });

                if (v.length > 0) {
                    sOrder =  v[0].sortOrder;
                }

            }
            if (sOrder == null) {
                return '';
            }
            if (isNaN(sOrder)) {
                return '';
            }

            return sOrder + '';
        },
        propertyValue() {
            if (this.versionId === "0") {
                return this.valueMaster;
            }
            return this.valueVersion;
        },
        valueMaster() {

            //return the master value
            return this.attributeOptionData.value;
        },
        valueVersion() {
            if (this.versionId != "0" && this.attributeOptionData.versions.length > 0) {
                //return the version
                let v = this.attributeOptionData.versions.filter(element => {
                    return ((element.languageId + '') == this.versionId)
                });

                if (v.length > 0) {
                    return v[0].value;
                }
            }

            //return the master value
            return '';
        },
        valueChangeType() {
            if (this.versionId != "0") {

                let v = this.attributeOptionData.versions.filter(element => {
                    return ((element.languageId + '') == this.versionId)
                });

                if (v.length == 0) {
                    return 'add-new-value';
                }
            }

            return 'value';

        }
    },
    methods: {
        handleDeleteRow() {
            axios.delete(base_url + '/userinterface/attributes/options/' + this.optionId, {})
                .then((response) => {
                    this.$emit('refresh-options');
                })
                .catch((error) => {
                    this.$emit('error', error);
                });
        }
    }
}
</script>

<style>
.edit-in-place-cell {
    margin: 3px 6px 3px 0;
}
</style>
